<template>
  <div>
    <div ref="map" class="google-map rounded-xl"></div>

    <div class="flex ">
      <div class="mt-5">
        <p class="text-lg">Scopri se sono presenti compravendite nella zona. <br>Utilizza i filtri qui sotto.</p>


      </div>

    </div>


    <div class="grid grid-cols-4 p-4 bg-white mt-4">
      <div class="mt-3 mr-4">

        <p class="font-semibold text-lg">Raggio d'azione (in metri)*</p>
        <div class="mt-2 flex items-center space-x-8  ">
          <input v-model.number="radius" type="number" class="rounded-md h-10   py-2 pl-2 border border-gray-500"
                 id="raggio">

        </div>
        <span class="text-xs" style="line-height:0px !important; padding:0;">
            * E' la distanza, dal centro del poligono,<br> entro la quale il sistema controllerà <br>se ci sono atti di vendita.
        </span>

      </div>
      <div class="mt-3 mr-4">

        <p class="font-semibold text-lg">Superficie</p>
        <div class="mt-2 flex items-center space-x-8  ">
          min (mq)&nbsp;
          <input v-model.number="surface_min" type="text" class="rounded-md h-10   py-2 pl-2 border border-gray-500"
                 id="superficiemin">

        </div>
        <div class="mt-2 flex items-center space-x-8  ">
          max (mq)&nbsp;
          <input v-model.number="surface_max" type="text" class="rounded-md h-10   py-2 pl-2 border border-gray-500"
                 id="superficiemax">

        </div>

      </div>

      <div class="mt-3 mr-4">

        <p class="font-semibold text-lg">Prezzo</p>
        <div class="mt-2 flex items-center space-x-8  ">
          min&nbsp;
          <input v-model.number="price_min" type="text" class="rounded-md h-10   py-2 pl-2 border border-gray-500"
                 id="prezzomin">

        </div>
        <div class="mt-2 flex items-center space-x-8  ">
          max&nbsp;
          <input v-model.number="price_max" type="text" class="rounded-md h-10   py-2 pl-2 border border-gray-500"
                 id="prezzomax">

        </div>

      </div>


      <div class="mt-3">
        <p class="font-semibold text-lg">Limite MASSIMO dei risultati</p>
        <div class="mt-2 flex items-center space-x-8  ">
          <input v-model.number="limit" type="number" class="rounded-md h-10  w-full py-2 pl-2 border border-gray-500"
                 min="1"
                 max="200"

                 id="raggio">

        </div>
      </div>


    </div>

    <div class="mt-4 text-right">
      <button
          v-if="walletTotal"
          id="btn" class="p-2 rounded-md bg-[#EF7B10] hover:bg-[#5e647c] text-white font-bold" type="button"
          @click="searchTrades()">Cerca Atti di vendita
      </button>

      <a
          href="/services/wallet"
          v-if="!walletTotal"
          id="btn" class="p-2 rounded-md bg-[#EF7B10] hover:bg-[#5e647c] text-white font-bold" type="button"
      >Oops! Ricarica il tuo wallet prima di procedere
      </a>
    </div>

    <div class="mt-5 text-white bg-red-500 p-4" v-if="errorSales">{{ errorSales }}</div>


    <div v-if="sales" class="mt-5">
      <p class="text-2xl font-semibold">Atti di vendita nella zona selezionata</p>

      <div class="mt-5 bg-gray-50 p-4" v-if="!showDetail">
        <div class="flex justify-between space-y-6 border-b-2 py-3" v-for="(sale, index) in sales">
          <div>
            <p class="text-lg font-semibold">Atto di vendita</p>
            <p class="mt-2">{{ sale.atto_vendita }}</p>
          </div>

          <div>
            <P class="text-lg font-semibold">Totale immobili</P>
            <p class="mt-2">{{ sale.totale_immobili }}</p>
          </div>

          <div>
            <p class="text-lg font-semibold">Prezzo</p>
            <p class="mt-2">{{ priceFormatter(sale.prezzo) }}</p>
          </div>

          <div>
            <button @click="showInfo(index)"
                    class="p-2 bg-[#EF7B10] hover:bg-[#5e647c] rounded-md text-white font-semibold">Più info
            </button>
          </div>


        </div>



      </div>
      <div v-if="showDetail">
        &laquo; <button type="button" class="btn btn-info"  @click="showDetail = false">torna indietro</button>
        <div v-if=" moreInfo && index === indexAtto" v-for="(sale,index) in sales"
             class="p-6 bg-[#ADD1D9] rounded-md mt-2">

          <p class="text-lg font-bold">Dettaglio immobili - Atto {{ sale.atto_vendita }} -- Prezzo:
            {{ priceFormatter(sale.prezzo) }}</p>

          <div v-for="houses in sale.immobili" class="mt-4 flex justify-between">
            <div>
              <p class="bold">Anno:</p>
              {{ houses.annoStipula }}
            </div>
            <div>
              <p class="bold">Tipologia atto:</p>
              {{ houses.tipologiaAtto }}
            </div>
            <div>
              <p class="bold">Indirizzo</p>
              <a target="_blank" class="hover:underline text-indigo-500"
                 :href="'https://www.google.com/maps/search/?api=1&query=' + houses.location_point.coordinates">
                {{ houses.indirizzo }}
              </a>
            </div>
            <div>
              <p class="bold">Consistenza</p>
              {{ houses.consistenza }}
            </div>
            <div>
              <p class="bold">Zona:</p>
              {{ houses.zona }}
            </div>
            <div>
              <p class="bold">Categoria:</p>
              {{ houses.categoriaCat }}
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  props: ['zoneInfo'],
  data() {
    return {
      sales: null,
      errorSales: null,
      radius: 20,
      showDetail: false,
      surface_min: 50,
      surface_max: 200,
      price_min: 30000,
      price_max: 1000000,
      categories: ['A'],
      limit: 1,
      moreInfo: false,
      indexAtto: null,
      walletOk: 0,
      walletTotal: 0,
    }
  },
  mounted() {
    this.initMap();
    this.checkWallet();
  },
  watch: {
    'zoneInfo.latlng': function (newVal, oldVal) {
      this.initMap();
    }
  },

  methods: {

    showInfo(payload) {
      this.moreInfo = !this.moreInfo
      this.indexAtto = payload
      this.showDetail = true;
    },


    initMap() {
      const zoneCenter = JSON.parse(this.zoneInfo.latlng);

      const center = { lat: zoneCenter[0], lng: zoneCenter[1] };
      const zoom = 15;

      const map = new google.maps.Map(this.$refs.map, {
        center,
        zoom,
      });

      map.addListener('click', (event) => {
        this.handleClick(event.latLng);
      });

      if (this.zoneInfo.polygon) {
        // Caso con poligono
        let zoneCoordinates = JSON.parse(this.zoneInfo.polygon).map(function (coord) {
          let [lat, lng] = coord.split(",");
          return { lat: parseFloat(lat), lng: parseFloat(lng) };
        });

        let polygon = new google.maps.Polygon({
          paths: zoneCoordinates,
          map: map,
        });
      } else if (this.zoneInfo.radius) {
        // Caso con cerchio
        let radius = JSON.parse(this.zoneInfo.radius); // Assume che il raggio sia in metri

        let circle = new google.maps.Circle({
          center: center,
          radius: radius,
          map: map,
        });
      }

      if (this.sales) {
        this.sales.forEach((sale) => {
          const price = sale.prezzo;
          const formattedPrice = price.toLocaleString('it-IT', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          let infoWindow = new google.maps.InfoWindow({
            content: '<strong>Atto di vendita: </strong>' + sale.atto_vendita + '<br>' + '<strong>Totale Immobili: </strong>' + sale.totale_immobili + '<br>' + '<strong>Prezzo: </strong>' + formattedPrice,
          });

          let marker = new google.maps.Marker({
            position: {
              lat: sale.immobili[0].location_point.coordinates[0],
              lng: sale.immobili[0].location_point.coordinates[1],
            },
            map: map,
            title: 'Atto',
          });

          marker.addListener('click', () => {
            infoWindow.open(map, marker);
          });
        });
      }
    },


/*
    oldInitMap() {

      const zoneCenter = JSON.parse(this.zoneInfo.latlng)

      let zoneCoordinates = JSON.parse(this.zoneInfo.polygon).map(function (coord) {
        let [lat, lng] = coord.split(",");
        return {lat: parseFloat(lat), lng: parseFloat(lng)};
      });


      const center = {lat: zoneCenter[0], lng: zoneCenter[1]};
      const zoom = 15;

      const map = new google.maps.Map(this.$refs.map, {
        center,
        zoom,
      });

      map.addListener('click', (event) => {
        this.handleClick(event.latLng);
      });

      let polygon = new google.maps.Polygon({
        paths: zoneCoordinates,
        map: map,
      });

      if (this.sales) {
        this.sales.forEach((sale) => {
          const price = sale.prezzo
          const formattedPrice = price.toLocaleString('it-IT', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })

          let infoWindow = new google.maps.InfoWindow({
            content: '<strong>Atto di vendita: </strong>' + sale.atto_vendita + '<br>' + '<strong>Totale Immobili: </strong>' + sale.totale_immobili + '<br>' + '<strong>Prezzo: </strong>' + formattedPrice
          })

          let marker = new google.maps.Marker({
            position: {
              lat: sale.immobili[0].location_point.coordinates[0],
              lng: sale.immobili[0].location_point.coordinates[1]
            },
            map: map,
            title: 'Atto'
          })

          marker.addListener('click', () => {
            infoWindow.open(map, marker);
          });
        });
      }

    },
*/



    handleClick(latLng) {
      this.lat = latLng.lat();
      this.lng = latLng.lng();
    },


    priceFormatter(payload) {
      return payload.toLocaleString('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    checkWallet() {
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.get('/api/v2/wallet/checkCredit/compravendita')
          .then(response => {
            this.walletOk = response.data;
          })

      axios.get('/api/v2/wallet/total')
          .then(response => {
            this.walletTotal = response.data.walletTotal.total;
          })

    },

    checkDataBeforeSend() {

      let isOk = 1;


      if (typeof this.surface_min !== 'number') {
        console.info('superficie minima')
        isOk = 0;
      }

      if (typeof this.surface_max !== 'number') {
        console.info('superficie massima')
        isOk = 0;
      }

      if (typeof this.price_min !== 'number') {
        console.info('  prezzo minimo')
        isOk = 0;
      }

      if (typeof this.price_max !== 'number') {
        console.info('  prezzo massimo')
        isOk = 0;
      }

      if (typeof this.radius !== 'number') {
        isOk = 0;
      }

      if (typeof this.limit !== 'number') {
        console.info(typeof this.limit)
        isOk = 0;
      }
      if (this.categories.length === 0) {
        console.info('categoria')
        isOk = 0;
      }

      if (isOk === 0) {
        this.errorSales = 'Per favore, tutti i campi sono obbligatori';
      }


      return isOk;
    },

    searchTrades() {

      this.errorSales = '';
      if (this.checkDataBeforeSend() === 1) {
        let availableResult = this.walletTotal / 3;

        if (availableResult < this.limit) {
          this.errorSales = 'Hai richiesto risultati superiori al valore del tuo wallet (' + this.walletTotal + ' crediti)';
        } else {
          const zoneCenter = JSON.parse(this.zoneInfo.latlng)
          axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
          axios.defaults.headers.common['Accept'] = 'application/json';
          axios.post('/api/v2/trades/search', {
            lat: zoneCenter[0],
            lng: zoneCenter[1],
            rad: this.radius,
            limit: this.limit,
            surface_min: this.surface_min,
            surface_max: this.surface_max,
            // categories: this.categories,
            price_min: this.price_min,
            price_max: this.price_max,
            zone_id: this.zoneInfo.id,
          })
              .then(response => {
                this.sales = response.data;
                this.initMap();
              })
              .catch(error => {
                this.errorSales = 'Servizio momentaneamente non disponibile, debug: ' + error.message;
              });
        }
      }


    },

  },
};
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;


.google-map {
  width: 100%;
  height: 400px;
}
</style>
